// Important  Javascript Dependencies to Bootstrap our App
// For Manipulation of Array, Collections and Objects in Javascript
import lodash from "lodash";
// Main Dependency of our Vue App
import Vue from "vue";
// Our App Routing
import VueRouter from "vue-router";

import { formatValue, formatDate } from './filters';
// For Time Related Functions
import Moment from "moment";
import { extendMoment } from "moment-range";
// Making HTTP Request
import axios from "axios";

import { EventBus } from "./event-bus.js";

/*
 Install Plugins
*/
// For Form Validation
import VeeValidate, { Validator } from "vee-validate";
import fr from "vee-validate/dist/locale/fr";

// For textarea autoresize
import VueAutosize from "vue-autosize";
// For Scrolling
import VueScrollTo from "vue-scrollto";
// Section For Your VueJS Themes
import Buefy from "buefy";
// loads the wysiwyg plugin
import VueQuillEditor from "vue-quill-editor";
import "quill-paste-smart";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import QuillEditorComponent from './components/TextEditor.vue';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';



// Log error on sentry.io
import * as Sentry from '@sentry/browser';
import VueObserveVisibility from 'vue-observe-visibility'



Sentry.init({ dsn: 'https://65bcca2bc7374382b1a1796458f890a8@sentry.io/231631' });

Validator.localize("fr", fr);

Vue.use(Buefy, {
  defaultDayNames: ['Dim','Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
  defaultMonthNames: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
  defaultFirstDayOfWeek: 1,
  defaultDateFormatter: date => date.toLocaleDateString('fr-Fr')
})

Vue.use(VeeValidate, {
  validity: false,
  locale: "fr",
  delay: 300,
  strict: false,
  events: ""
});

Vue.use(VueObserveVisibility)

Vue.use(VueAutosize);

Vue.use(VueScrollTo);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

// This Buefy Constructor can be Configure Check:
// https://buefy.github.io/?#/documentation/constructor-options
Vue.use(Buefy);

Vue.use(VueQuillEditor);
Vue.component('text-editor-component', QuillEditorComponent);

Vue.filter('formatValue', formatValue);
Vue.filter('formatDate', formatDate);

// Global Access
window.Vue = Vue;
window.axios = axios;
window._ = lodash;
window.moment = extendMoment(Moment);
window.moment.locale("fr");
window.router = VueRouter;
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// Always Add this Header in Each Request
window.axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest"
};

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error(
    "CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token"
  );
}

// Add Interceptors for Token
axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    const AUTH_TOKEN = localStorage.getItem("token");

    if (AUTH_TOKEN) {
      config.headers.common["Authorization"] = `Bearer ${AUTH_TOKEN}`;
    }

    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response.status === 401) {
      EventBus.$emit("error:401", error.response.data);
      return Promise.reject(error);
    } else {
      EventBus.$emit("error", error.response.data);
      return Promise.reject(error);
    }
  }
);

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: 'your-pusher-key'
// });
